import React, { useState } from 'react';
import './ContactDetailPopup.css';
import MarketerPromotionDialog from '../MarketerPromotionDialog/MarketerPromotionDialog';
import DemotionConfirmDialog from '../DemotionConfirmDialog/DemotionConfirmDialog';

function ContactDetailPopup({ contact, onClose, onEdit, onDelete, onContactUpdate }) {
  const [showPromoteDialog, setShowPromoteDialog] = useState(false);
  const [showDemoteDialog, setShowDemoteDialog] = useState(false);

  if (!contact) return null;

  const handlePromote = (updatedContact) => {
    if (onContactUpdate) {
      onContactUpdate(updatedContact);
    }
  };

  const handleDemote = (updatedContact) => {
    if (onContactUpdate) {
      onContactUpdate(updatedContact);
    }
  };

  return (
    <div className="contact-detail-overlay" onClick={onClose}>
      <div className="contact-detail-popup" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <h2>{contact.first_name} {contact.last_name}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="contact-info">
          <div className="info-row">
            <strong>Email:</strong> {contact.email || 'Not provided'}
          </div>
          <div className="info-row">
            <strong>Phone:</strong> {contact.phone || 'Not provided'}
          </div>
          <div className="info-row">
            <strong>Location:</strong> {contact.city && contact.country ? `${contact.city}, ${contact.country}` : 'Not provided'}
          </div>
          <div className="info-row">
            <strong>Source:</strong> {contact.source || 'Not provided'}
          </div>
          <div className="info-row">
            <strong>Status:</strong> 
            <span className={`status-badge status-${contact.status}`}>
              {contact.status.charAt(0).toUpperCase() + contact.status.slice(1)}
            </span>
          </div>
        </div>

        {/* Network Marketing Section */}
        {contact.status === 'customer' && (
          <div className="network-marketing-section">
            <h3>Network Marketing</h3>
            <p>Promote this customer to become a marketer in your network.</p>
            <button 
              className="promote-btn"
              onClick={() => setShowPromoteDialog(true)}
            >
              🚀 Promote to Marketer
            </button>
          </div>
        )}

        {contact.status === 'marketer' && (
          <div className="marketer-info-section">
            <h3>Marketer Information</h3>
            <div className="info-row">
              <strong>Company:</strong> {contact.network_company_name || 'Not set'}
            </div>
            <div className="info-row">
              <strong>Member ID:</strong> {contact.network_member_id || 'Not set'}
            </div>
            <div className="info-row">
              <strong>Promoted:</strong> {contact.promoted_to_marketer_at ? new Date(contact.promoted_to_marketer_at).toLocaleDateString() : 'Unknown'}
            </div>
            <button 
              className="demote-btn"
              onClick={() => setShowDemoteDialog(true)}
            >
              ⬇️ Demote to Customer
            </button>
          </div>
        )}


        <div className="popup-actions">
          <button className="edit-btn" onClick={() => onEdit(contact)}>
            Edit Contact
          </button>
          <button className="delete-btn" onClick={() => onDelete(contact.id)}>
            Delete Contact
          </button>
          <button className="close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>

      {/* Promotion Dialog */}
      {showPromoteDialog && (
        <MarketerPromotionDialog
          contact={contact}
          onClose={() => setShowPromoteDialog(false)}
          onPromote={handlePromote}
        />
      )}

      {/* Demotion Dialog */}
      {showDemoteDialog && (
        <DemotionConfirmDialog
          contact={contact}
          onClose={() => setShowDemoteDialog(false)}
          onDemote={handleDemote}
        />
      )}
    </div>
  );
}

export default ContactDetailPopup;
